/* eslint-disable */
// Victory-track star — matches the ★ glyphs used on the victory
// panel's milestone rows. Fill-only path like the other UI icons.
var icon = require('vue-svgicon')
icon.register({
  'victory': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 1.5 L12.35 7.26 L18.56 7.72 L13.8 11.74 L15.29 17.78 L10 14.5 L4.71 17.78 L6.2 11.74 L1.44 7.72 L7.65 7.26 Z"/>'
  }
})
